var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRoadSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2e3e9"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.348,
    x2: 284.652,
    xlinkHref: "#lg1",
    y1: 246.438,
    y2: 246.438
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a2e3e9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#518cd2"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 303.006,
    x2: 185.084,
    xlinkHref: "#lg2",
    y1: 95.815,
    y2: -27.906
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 303.006,
    x2: 185.084,
    xlinkHref: "#lg2",
    y1: 339.994,
    y2: 216.273
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 35.659,
    y2: 48.083
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.023,
    x2: 256.185,
    y1: 487.34,
    y2: 510.645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4a72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.577,
    x2: 170.103,
    y1: 209.67,
    y2: 383.588
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3fa9f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666ad6"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(-1 0 0 1 289.559 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -77.865,
    x2: -50.338,
    y1: 117.081,
    y2: 290.999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#ffde50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#ffca65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#ffaa87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff90a4"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fba5c2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3857,
    stopColor: "#fca0ba",
    stopOpacity: 0.386
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9737,
    stopColor: "#ff91a5",
    stopOpacity: 0.974
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff90a4"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.923,
    x2: 292.923,
    xlinkHref: "#lg3",
    y1: 189.349,
    y2: 138.349
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 371.255,
    x2: 323.921,
    xlinkHref: "#lg3",
    y1: 182.282,
    y2: 138.282
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 419.396,
    x2: 362.73,
    xlinkHref: "#lg3",
    y1: 189.673,
    y2: 128.673
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 445.628,
    x2: 397.214,
    xlinkHref: "#lg3",
    y1: 174.903,
    y2: 125.039
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 311.732,
    x2: 309.065,
    xlinkHref: "#lg1",
    y1: 136.876,
    y2: 201.542
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.766,
    x2: 345.099,
    xlinkHref: "#lg1",
    y1: 138.362,
    y2: 203.028
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.681,
    x2: 381.014,
    xlinkHref: "#lg1",
    y1: 139.843,
    y2: 204.509
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 417.255,
    x2: 414.589,
    xlinkHref: "#lg1",
    y1: 141.227,
    y2: 205.894
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a34a9e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343168"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.748,
    x2: 80.748,
    xlinkHref: "#lg4",
    y1: 288.585,
    y2: 227.585
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.277,
    x2: 119.277,
    xlinkHref: "#lg4",
    y1: 281.792,
    y2: 220.125
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.336,
    x2: 154.67,
    xlinkHref: "#lg4",
    y1: 282.263,
    y2: 221.263
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.164,
    x2: 188.497,
    xlinkHref: "#lg4",
    y1: 274.197,
    y2: 216.864
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.626,
    x2: 92.626,
    xlinkHref: "#lg1",
    y1: 230.667,
    y2: 297.417
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.215,
    x2: 141.215,
    xlinkHref: "#lg1",
    y1: 230.667,
    y2: 297.417
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.535,
    x2: 174.535,
    xlinkHref: "#lg1",
    y1: 230.667,
    y2: 297.417
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.509,
    x2: 209.509,
    xlinkHref: "#lg1",
    y1: 230.667,
    y2: 297.417
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m284.652 492.876h-59.304v-463.224c0-16.376 13.276-29.652 29.652-29.652 16.376 0 29.652 13.276 29.652 29.652z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m225.348 47.517 59.304 59.304v-63.441h-59.304z",
    fill: "url(#SVGID_2_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m225.348 291.696 59.304 59.304v-63.441h-59.304z",
    fill: "url(#SVGID_3_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m284.668 47.145h-59.335c-3.869 0-7.006-3.137-7.006-7.006 0-3.869 3.137-7.006 7.006-7.006h59.335c3.869 0 7.006 3.137 7.006 7.006 0 3.869-3.137 7.006-7.006 7.006z",
    fill: "url(#SVGID_4_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m322.668 510h-135.336v-9.786c0-13.51 10.952-24.463 24.463-24.463h86.411c13.51 0 24.463 10.952 24.463 24.463v9.786z",
    fill: "url(#SVGID_5_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m284.652 292h-235.642c-7.419 0-14.485-3.166-19.424-8.703l-18.076-20.268c-8.804-9.871-8.804-24.776 0-34.647l18.077-20.268c4.938-5.537 12.005-8.703 19.424-8.703h235.642v92.589z",
    fill: "url(#SVGID_6_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m273.727 284.739h-214.498c-7.635 0-14.964-2.801-20.106-7.686l-16.147-15.338c-4.607-4.376-7.145-10.063-7.145-16.012.001-5.948 2.538-11.634 7.145-16.009l16.147-15.338c5.142-4.884 12.471-7.686 20.106-7.686h214.497v78.069zm-214.498-70.067c-5.606 0-10.927 2-14.597 5.486l-16.147 15.338c-3.001 2.85-4.653 6.476-4.654 10.209 0 3.733 1.653 7.359 4.654 10.21l16.147 15.338c3.671 3.486 8.991 5.486 14.597 5.486h206.497v-62.067z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m225.348 199.411h235.642c7.419 0 14.485-3.166 19.424-8.703l18.077-20.268c8.804-9.871 8.804-24.776 0-34.647l-18.077-20.268c-4.938-5.537-12.005-8.703-19.424-8.703h-235.642z",
    fill: "url(#SVGID_7_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m450.771 192.149h-214.498v-78.067h214.497c7.635 0 14.964 2.802 20.106 7.686l16.147 15.338c4.607 4.376 7.145 10.063 7.145 16.012-.001 5.948-2.538 11.634-7.145 16.009l-16.147 15.338c-5.141 4.883-12.47 7.684-20.105 7.684zm-206.498-8h206.497c5.606 0 10.927-2 14.597-5.486l16.147-15.338c3.001-2.85 4.653-6.476 4.654-10.209 0-3.733-1.653-7.359-4.654-10.21l-16.147-15.338c-3.671-3.486-8.991-5.486-14.597-5.486h-206.497z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m394.4 199.41h-73.74l-23.54-23.54c-.86-.54-1.3-1.31-1.3-2.3v-41.17c0-.99.44-1.76 1.3-2.3s1.9-.81 3.11-.81h23.08c.99 0 1.75.43 2.27 1.3l11.22 11.22z",
    fill: "url(#SVGID_8_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m420.42 199.41h-66.91l-24.13-24.12c-1.23-.78-1.86-1.7-1.86-2.76 0-.13.05-.36.13-.71l9.15-30.01 2.91-9.54c.35-1.08 1.14-1.91 2.37-2.49 1.23-.59 2.64-.88 4.24-.88s3.02.29 4.25.88c.98.46 1.66 1.09 2.08 1.86z",
    fill: "url(#SVGID_9_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m463.58 199.41h-68.27l-26.02-26.03c-1.73-1.36-2.6-2.84-2.61-4.44v-.04c0-1.21.44-2.42 1.33-3.63.88-1.21 1.91-1.81 3.08-1.81.65 0 1.37.26 2.17.78.8.53 1.53 1.11 2.2 1.74.67.64 1.61 1.22 2.82 1.75 1.21.52 2.49.78 3.83.78 1.68 0 3.15-.35 4.41-1.07.15-.08.29-.17.42-.27l-14.4-14.43c-.95-.83-1.82-1.79-2.59-2.9-.43-.62-.79-1.28-1.08-1.98-.68-1.57-1.02-3.33-1.02-5.28 0-2.49.48-4.63 1.44-6.44.8-1.52 1.94-2.8 3.42-3.83 3.24-2.27 7.15-3.41 11.73-3.41 1.13 0 2.3.07 3.54.2 1.23.14 2.61.39 4.14.77 1.54.38 2.79.99 3.76 1.84z",
    fill: "url(#SVGID_10_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m486.8 183.54-6.39 7.17c-4.38 4.91-10.45 7.97-16.96 8.57l.13.13h-26.03l-23.55-23.55c-.99-.54-1.49-1.31-1.49-2.31v-25.44l-9.87-10.18c-.52-.2-.96-.56-1.31-1.11-.54-.86-.81-1.92-.81-3.18 0-1.18.26-2.2.78-3.06s1.27-1.29 2.27-1.29h28c1 0 1.75.43 2.27 1.29z",
    fill: "url(#SVGID_11_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m295.824 173.569v-41.166c0-.994.431-1.76 1.297-2.301.864-.54 1.901-.81 3.112-.81h23.079c.994 0 1.75.432 2.269 1.297.518.865.778 1.88.778 3.047 0 1.254-.27 2.313-.81 3.177-.541.865-1.286 1.297-2.236 1.297h-17.374v10.956h9.724c.95 0 1.696.389 2.237 1.167.54.778.81 1.708.81 2.788 0 .995-.259 1.88-.778 2.658s-1.275 1.167-2.269 1.167h-9.724v11.021h17.374c.95 0 1.695.433 2.236 1.297.54.865.81 1.923.81 3.177 0 1.167-.259 2.183-.778 3.047-.519.865-1.275 1.297-2.269 1.297h-23.079c-1.21 0-2.248-.27-3.112-.81-.866-.544-1.297-1.311-1.297-2.306z",
    fill: "url(#SVGID_12_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m327.524 172.532c0-.13.042-.367.13-.713l12.058-39.545c.346-1.08 1.134-1.913 2.366-2.496s2.647-.875 4.246-.875c1.598 0 3.014.292 4.246.875s2.02 1.416 2.366 2.496l12.123 39.545c.086.346.13.583.13.713 0 1.125-.703 2.097-2.107 2.917-1.405.821-2.864 1.232-4.376 1.232-1.859 0-2.961-.626-3.306-1.88l-2.204-8.104h-13.679l-2.204 8.104c-.346 1.254-1.448 1.88-3.306 1.88-1.513 0-2.972-.41-4.376-1.232-1.405-.82-2.107-1.792-2.107-2.917zm14.067-13.614h9.465l-4.732-17.374z",
    fill: "url(#SVGID_13_)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m366.679 168.902c0-1.209.443-2.42 1.329-3.63.885-1.21 1.913-1.815 3.079-1.815.648 0 1.372.262 2.172.786.799.525 1.534 1.105 2.204 1.742.67.638 1.61 1.219 2.82 1.742 1.21.525 2.485.786 3.825.786 1.685 0 3.154-.357 4.408-1.07 1.253-.713 1.88-1.783 1.88-3.209s-.703-2.679-2.107-3.76c-1.405-1.08-3.112-2.063-5.121-2.95-2.009-.885-4.03-1.88-6.061-2.982-2.032-1.102-3.75-2.668-5.154-4.7-1.405-2.031-2.107-4.451-2.107-7.261 0-4.581 1.621-8.006 4.862-10.275s7.152-3.403 11.734-3.403c1.123 0 2.301.067 3.533.201s2.614.39 4.149.769c1.534.379 2.788.991 3.76 1.837.973.847 1.459 1.871 1.459 3.072 0 1.142-.357 2.328-1.07 3.557-.713 1.23-1.697 1.844-2.949 1.844-.519 0-1.621-.41-3.306-1.232-1.686-.821-3.544-1.232-5.575-1.232-2.161 0-3.782.379-4.862 1.134-1.081.757-1.621 1.675-1.621 2.755 0 .994.507 1.902 1.523 2.722 1.015.821 2.279 1.524 3.793 2.107 1.512.583 3.165 1.34 4.959 2.269 1.793.93 3.446 1.945 4.959 3.047 1.512 1.102 2.777 2.648 3.793 4.635 1.015 1.988 1.523 4.257 1.523 6.807 0 4.457-1.491 7.926-4.473 10.409s-6.894 3.723-11.734 3.723c-4.193 0-7.844-.864-10.956-2.593-3.112-1.726-4.668-3.671-4.668-5.832z",
    fill: "url(#SVGID_14_)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m400.518 133.638c0-1.175.259-2.193.778-3.054s1.274-1.291 2.269-1.291h28.006c.994 0 1.75.43 2.269 1.291s.778 1.879.778 3.054c0 1.26-.27 2.32-.81 3.181-.541.861-1.286 1.29-2.237 1.29h-8.946v35.439c0 1.001-.497 1.774-1.491 2.317-.995.544-2.183.816-3.565.816-1.384 0-2.572-.272-3.566-.816-.995-.544-1.491-1.317-1.491-2.317v-35.439h-8.946c-.951 0-1.697-.43-2.237-1.29-.541-.862-.811-1.921-.811-3.181z",
    fill: "url(#SVGID_15_)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m189.14 292h-87.75l-23.54-23.55c-.92-.55-1.53-1.27-1.82-2.16l-12.9-39.55c-.09-.26-.13-.54-.13-.84 0-1.04.7-1.97 2.11-2.79 1.4-.82 2.88-1.23 4.44-1.23 1.76 0 2.82.6 3.2 1.78l14.4 14.08.61-2.63c.18-.82.74-1.47 1.69-1.95.95-.47 2.01-.71 3.18-.71 1.16 0 2.22.24 3.17.71.79.39 1.29.91 1.55 1.54l9.16 9.15 5.95-20.09c.35-1.25 1.43-1.88 3.24-1.88 1.56 0 3.04.41 4.45 1.23l5.8 5.79 32.67 32.63z",
    fill: "url(#SVGID_16_)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m224.52 292h-73.74l-23.54-23.54c-.86-.54-1.29-1.31-1.29-2.3v-41.17c0-.99.43-1.76 1.29-2.3.87-.54 1.91-.81 3.12-.81h23.07c1 0 1.75.43 2.27 1.3.01.02 2.08 2.09 5.53 5.55 13.46 13.47 47.91 47.9 63.29 63.27z",
    fill: "url(#SVGID_17_)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m255.52 292h-68.27l-26.02-26.03c-1.73-1.36-2.6-2.84-2.61-4.44v-.04c0-1.21.44-2.42 1.33-3.63.88-1.21 1.91-1.81 3.08-1.81.65 0 1.37.26 2.17.78.8.53 1.53 1.11 2.2 1.74.67.64 1.61 1.22 2.82 1.75 1.21.52 2.49.78 3.83.78 1.68 0 3.15-.35 4.41-1.07.15-.08.29-.17.42-.27l-14.4-14.43c-.95-.83-1.82-1.79-2.59-2.9-1.4-2.03-2.1-4.45-2.1-7.26 0-2.49.48-4.63 1.44-6.44.8-1.52 1.94-2.8 3.42-3.83 3.24-2.27 7.15-3.41 11.73-3.41 1.13 0 2.3.07 3.54.2 1.23.14 2.61.39 4.14.77 1.54.38 2.79.99 3.76 1.84z",
    fill: "url(#SVGID_18_)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m284.65 282.04v9.96h-55.16l-23.55-23.55c-.99-.54-1.49-1.31-1.49-2.31v-25.44l-9.87-10.18c-.52-.2-.96-.56-1.31-1.11-.54-.86-.81-1.92-.81-3.18 0-1.18.26-2.2.78-3.06s1.27-1.29 2.27-1.29h28c1 0 1.75.43 2.27 1.29z",
    fill: "url(#SVGID_19_)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m63 225.9c0-1.037.702-1.966 2.107-2.788 1.404-.82 2.885-1.231 4.441-1.231 1.815 0 2.895.627 3.241 1.88l9.854 33.256 5.121-21.912c.172-.821.734-1.469 1.686-1.945.95-.475 2.009-.713 3.177-.713 1.167 0 2.225.238 3.177.713.95.476 1.512 1.124 1.685 1.945l5.121 21.912 9.854-33.256c.345-1.253 1.426-1.88 3.241-1.88 1.556 0 3.036.411 4.441 1.231 1.404.821 2.107 1.751 2.107 2.788 0 .303-.044.583-.13.843l-12.901 39.545c-.389 1.081-1.199 1.912-2.431 2.496-1.232.583-2.648.875-4.246.875-1.599 0-3.025-.292-4.279-.875-1.254-.584-2.009-1.415-2.269-2.496l-3.371-15.364-3.371 15.364c-.259 1.081-1.016 1.912-2.269 2.496-1.254.583-2.68.875-4.279.875-1.6 0-3.026-.292-4.279-.875-1.254-.584-2.053-1.415-2.399-2.496l-12.899-39.544c-.087-.26-.13-.54-.13-.844z",
    fill: "url(#SVGID_20_)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m125.948 266.159v-41.166c0-.994.431-1.76 1.297-2.301.864-.54 1.901-.81 3.112-.81h23.079c.994 0 1.75.432 2.269 1.297.518.865.778 1.88.778 3.047 0 1.254-.27 2.313-.81 3.177-.541.865-1.286 1.297-2.236 1.297h-17.374v10.956h9.724c.95 0 1.696.389 2.237 1.167.54.778.81 1.708.81 2.788 0 .995-.259 1.88-.778 2.658s-1.275 1.167-2.269 1.167h-9.724v11.021h17.374c.95 0 1.695.433 2.236 1.297.54.865.81 1.923.81 3.177 0 1.167-.259 2.183-.778 3.047-.519.865-1.275 1.297-2.269 1.297h-23.079c-1.21 0-2.248-.27-3.112-.81-.866-.545-1.297-1.312-1.297-2.306z",
    fill: "url(#SVGID_21_)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m158.62 261.491c0-1.209.443-2.42 1.329-3.63.885-1.21 1.913-1.815 3.079-1.815.648 0 1.372.262 2.172.786.799.525 1.534 1.105 2.204 1.742.67.638 1.61 1.219 2.82 1.742 1.21.525 2.485.786 3.825.786 1.685 0 3.154-.357 4.408-1.07 1.253-.713 1.88-1.783 1.88-3.209s-.703-2.679-2.107-3.76c-1.405-1.08-3.112-2.063-5.121-2.95-2.009-.885-4.03-1.88-6.061-2.982-2.032-1.102-3.75-2.668-5.154-4.7-1.405-2.031-2.107-4.451-2.107-7.261 0-4.581 1.621-8.006 4.862-10.275s7.152-3.403 11.734-3.403c1.123 0 2.301.067 3.533.201s2.614.39 4.149.769c1.534.379 2.788.991 3.76 1.837.973.847 1.459 1.871 1.459 3.072 0 1.142-.357 2.328-1.07 3.557-.713 1.23-1.697 1.844-2.949 1.844-.519 0-1.621-.41-3.306-1.232-1.686-.821-3.544-1.232-5.575-1.232-2.161 0-3.782.379-4.862 1.134-1.081.757-1.621 1.675-1.621 2.755 0 .994.507 1.902 1.523 2.722 1.015.822 2.279 1.524 3.793 2.107 1.512.583 3.165 1.34 4.959 2.269 1.793.93 3.446 1.945 4.959 3.047 1.512 1.102 2.777 2.648 3.793 4.635 1.015 1.988 1.523 4.257 1.523 6.807 0 4.457-1.491 7.926-4.473 10.409s-6.894 3.723-11.734 3.723c-4.193 0-7.844-.864-10.956-2.593-3.112-1.726-4.668-3.67-4.668-5.832z",
    fill: "url(#SVGID_22_)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m192.459 226.227c0-1.175.259-2.193.778-3.054s1.274-1.291 2.269-1.291h28.006c.994 0 1.75.43 2.269 1.291s.778 1.879.778 3.054c0 1.26-.27 2.32-.81 3.181-.541.861-1.286 1.29-2.237 1.29h-8.946v35.439c0 1.001-.497 1.774-1.491 2.318-.995.544-2.183.816-3.565.816-1.384 0-2.572-.272-3.566-.816-.995-.544-1.491-1.317-1.491-2.318v-35.439h-8.946c-.951 0-1.697-.43-2.237-1.29-.541-.862-.811-1.921-.811-3.181z",
    fill: "url(#SVGID_23_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoadSign);
export default __webpack_public_path__ + "static/media/icon-road-sign.ad8302549e8f3c6af2eda11ec104d29e.svg";
export { ForwardRef as ReactComponent };